var _g, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _circle2, _circle3, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlug = function SvgPlug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 995 741",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 482.73,
    cy: 714.93,
    fill: "#e6e7e8",
    rx: 398.16,
    ry: 25.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.83 136.64 522.55 124s-17.94 24.66-18.14 24.24 3.38 9.27 3.38 9.27 14.34.21 14.76 0 11.38 2.95 11.38 2.95",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.32 118.39a42.43 42.43 0 0 1-.26 13.43 46 46 0 0 1-6.71 16.58 51.71 51.71 0 0 1-13.85 14.73c-2.23 1.56-7.39 3.92-17.63 8.59-3.2 1.45-3.5 1.57-13.69 6.14l-19.09 8.56-10.82 4.86-12.13 5.44c-11.23 5.06-12.32 5.63-15.14 6.21a36.89 36.89 0 0 1-12.11.45c-6-.79-9.9-2.91-14.25-5-6.95-3.42-14.35-5.86-21.37-9.16-8.25-3.89-43.14-21.9-62.61-29.67 2.16-4.42 8.08-17.78 13.72-25.87 5.29 1.85 35.87 17.59 41.16 19.44l38.85 13.57 29.27-15.22 19.87-10.34 10.78-5.32",
    fill: "#55f99f",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 25.97,
    rx: 12.985,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.48,
    width: 42.97,
    x: 951.01,
    y: 691.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.08 712.72c-152.92 0-345.06-3.67-392-21.16-26.38-9.82-43.83-23.93-54.92-44.41-10.26-18.95-15-43.82-15-78.25V101.37a7.68 7.68 0 0 1 15.35 0V568.9c0 62.66 16.25 92 60 108.28 44.82 16.69 235 20.19 386.66 20.19a7.68 7.68 0 0 1 0 15.35z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.78 94.7a6.68 6.68 0 0 1 6.68 6.67V568.9c0 32.15 4.35 55 13.69 71.91s24.33 28.89 46.93 37.31c44.95 16.74 235.26 20.25 387 20.25a6.68 6.68 0 0 1 0 13.35c-276.9 0-365.82-11.47-391.66-21.09-26.14-9.74-43.42-23.7-54.39-44-10.18-18.81-14.92-43.52-14.92-77.78V101.37a6.67 6.67 0 0 1 6.67-6.67zm0-2a8.67 8.67 0 0 0-8.67 8.67V568.9c0 34.61 4.82 59.62 15.16 78.73 11.21 20.7 28.83 35 55.45 44.87 48.45 18 250.81 21.22 392.36 21.22a8.68 8.68 0 0 0 0-17.35c-139.43 0-340.34-3-386.31-20.13-43.24-16.1-59.31-45.19-59.31-107.34V101.37a8.68 8.68 0 0 0-8.68-8.67z",
    fill: "#12186d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.88 67.72h51.81v16.42c0 14.304-11.596 25.9-25.9 25.9s-25.9-11.596-25.9-25.9V67.72z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.78 65.09c10.91 0 20.24 2.66 24.06 6.42a5.38 5.38 0 0 0 1.85-3.79c0-5.64-11.6-10.22-25.91-10.22s-25.9 4.58-25.9 10.22a5.38 5.38 0 0 0 1.85 3.79c3.82-3.76 13.15-6.42 24.05-6.42z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.78,
    cy: 71.51,
    fill: "#fff",
    rx: 24.05,
    ry: 6.43,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.75,
    cy: 72.92,
    fill: "#12186d",
    rx: 5.03,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.25,
    cy: 72.92,
    fill: "#12186d",
    rx: 5.03,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.54 128.58-8.16-14.25-11.15 1.67-11-.62s-.8 8 6.83 8.52 10.31.57 10.31.57.21 12.8 9.09 16.31",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 6.11,
    rx: 2.84,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "rotate(176.77 505.24 126.847)",
    width: 17.03,
    x: 496.725,
    y: 123.792
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 6.11,
    rx: 2.9,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "rotate(176.77 504.403 133.882)",
    width: 17.75,
    x: 495.528,
    y: 130.827
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 6.11,
    rx: 2.9,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "rotate(176.77 504.46 141.217)",
    width: 17.75,
    x: 495.584,
    y: 138.162
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 6.04,
    rx: 2.86,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "rotate(176.77 505.508 147.75)",
    width: 17.54,
    x: 496.738,
    y: 144.731
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.61 202.28c-.08-2.61.26-5.82.18-8.37-.33-9.58-.68-18.42-1-24.64-1.13-19.62-18.83-29.78-22.07-31.86l-2.64-1.7-40.18-21.37-49 2.77-9.35 3.64c-11.05 4.31-21.49 13.22-22.57 25-4.68 51.08-3 182.25-3 182.25l104.02-.35 12.17-116.41c13.91-6.59 27.91-8.24 33.44-8.96z",
    fill: "#55f99f",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.19 375.29c.264.394.45.836.55 1.3a4 4 0 0 1 0 1.1c-.13 1.14-1.14 2.47-3.16 5.13-1.78 2.36-2.64 3.05-3.75 3.36a5.16 5.16 0 0 1-2.17.1 6.25 6.25 0 0 1-3.05 1.18 6.1 6.1 0 0 1-2.57-.3 5.93 5.93 0 0 1-6.1-.11 8.49 8.49 0 0 1-4.16.61 8.68 8.68 0 0 1-6.41-4.24 7.89 7.89 0 0 1-.3-6.91 4.23 4.23 0 0 1 2.17-2.37 3.74 3.74 0 0 1 2.27-.1 6.08 6.08 0 0 1-2.27.1 5.47 5.47 0 0 1-2.56-1c-2-1.64-.91-5.32-.79-5.73a10.66 10.66 0 0 1 2.27-3.75 26.16 26.16 0 0 1 4.14-4.24c1.79-1.57 4-4.26 5.62-9.17l17.86 1.67c.7 4.82 1 8.61 1.18 11.25.19 3 .89 6 .79 9.08a5.32 5.32 0 0 0 .44 3.04z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.33 375.29a5.27 5.27 0 0 0-.3 1.81 4.92 4.92 0 0 0 .5 2.07l2-1.48a10.45 10.45 0 0 1-3.85-8.68",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.92 157.65c7.15 17 9.61 113.67 9.61 113.67l-5.73 81.22-26.31-2.27 2.82-79.78-16.24-75.44",
    fill: "#55f99f",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.43 718c-18.8-11.28-33.84-15.39-39.54-16.65l12.59-374.74H671.77l18 374.55c-4.3.85-20.34 4.61-40.87 16.93h64l-.91-17.47-.16-331.45 17.4.22 7.64 333-.42 15.61z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751 88.56.65 25.5s-23.53 20.27-36.61 20.05-10.9-7-10.9-7v-32s37.3-27.91 46.86-6.55z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.79 94.65c0 .87.05 1.72.14 2.52 1.16 11 8.43 16.28 26.44 15.4a38.75 38.75 0 0 0 20.11-6.48L751 88.56c-8.83-19.75-41.35 2.6-46.21 6.09z",
    fill: "#12186d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 702.07,
    cy: 65.45,
    fill: "#fff",
    r: 8.28,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 757.35,
    cy: 67.42,
    fill: "#fff",
    r: 8.28,
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#12186d",
    height: 17.4,
    rx: 8.7,
    stroke: "#12186d",
    strokeWidth: 0.44,
    width: 17.4,
    x: 695.43,
    y: 25.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.88 32.76v52.31c0 8.72-11.91 20.34-29.93 21.21s-25.28-4.35-26.45-15.4 4.36-28.48 3.78-40.1-.51-17.36 2.33-25.21 43.88-2.83 50.27 7.19z",
    fill: "#fff",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.35 59.13s3.92-16.56 5.45-24.62S758 22.08 751 22.52s-9.81 3.7-9.81 3.7l2 3.93s10.68 1.74 11.34 9.15 0 21.09 0 21.09z",
    fill: "#12186d",
    stroke: "#12186d",
    strokeWidth: 0.44
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m719.66 52.77-3.88 19.81h8.83",
    stroke: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.22
  })), /*#__PURE__*/React.createElement("path", {
    d: "M718.24 84.39c0 .2.08.39.14.59A8.662 8.662 0 0 0 735 80.09c0-.13-.09-.25-.13-.38z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2.22,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 734.54,
    cy: 54.43,
    fill: "#12186d",
    fillRule: "nonzero",
    r: 2.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M709.24 52.32a2.11 2.11 0 1 0 2.19 2 2.12 2.12 0 0 0-2.19-2zM747.39 44.72c-2.72-3.89-7.71-5.44-12.27-4.92-2.81.33-2.84 4.77 0 4.45a9.86 9.86 0 0 1 6.71 1.23c.503.341.974.726 1.41 1.15.3.28.64.79.31.33 1.63 2.33 5.49.11 3.84-2.24zM707.18 46.2c-.32.46 0-.05.31-.33a10.5 10.5 0 0 1 1.42-1.15 9.9 9.9 0 0 1 6.7-1.24c2.84.33 2.82-4.12 0-4.44-4.55-.52-9.55 1-12.27 4.91-1.64 2.35 2.21 4.58 3.84 2.25z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M744 29.92s-11.4 5.48-23.84 4-23.25-8.73-24.74-24.73l4.45.6a18.12 18.12 0 0 1-.77-9.2S712.42 4 718.35 4.3a59.12 59.12 0 0 0-5.93-4S737.3-1.33 745 10.52s-1 19.4-1 19.4z",
    fill: "#12186d",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 0.44
  })), /*#__PURE__*/React.createElement("rect", {
    height: 24.85,
    rx: 12.425,
    style: {
      stroke: "#12186d",
      strokeWidth: 2.28,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(-173.6 22.59 698.082)",
    width: 41.12,
    x: 2.031,
    y: 685.657
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.42 241.87 429 233s12.64 22.23 12.84 21.89-3.68 7.42-3.68 7.42-12-1.17-12.3-1.38-9.76 1.39-9.76 1.39",
    style: {
      stroke: "#12186d",
      strokeWidth: 1.67,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.12 709.09c-53.18 0-118.34-1.42-193.65-4.22a6.682 6.682 0 0 1-6.331-6.791 6.682 6.682 0 0 1 6.571-6.559H24c76.54 2.85 142.38 4.29 195.69 4.29 78.61 0 128.08-3.18 147-9.44 39.26-13 54.62-38.43 56.68-93.9l15.38-413.54a6.64 6.64 0 0 1 6.67-6.42h.25a6.68 6.68 0 0 1 6.43 6.92L436.69 593c-1.13 30.44-6.17 52.26-15.86 68.67-10.47 17.72-26.35 29.61-50 37.42-20.14 6.66-71.86 10-153.72 10z",
    fill: "#fff",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M445.39 173.51h.21a5.695 5.695 0 0 1 5.473 5.88L435.69 592.93c-1.12 30.26-6.12 51.93-15.72 68.19-10.34 17.5-26 29.25-49.43 37-20 6.63-71.65 10-153.41 10-53.17 0-118.32-1.42-193.63-4.22a5.682 5.682 0 0 1-5.361-5.776 5.682 5.682 0 0 1 5.571-5.574h.22c76.54 2.85 142.39 4.29 195.73 4.29 78.71 0 128.28-3.19 147.32-9.49 20.32-6.72 33.94-16.74 42.85-31.56s13.45-34.79 14.51-63.29L439.72 179a5.64 5.64 0 0 1 5.67-5.46zm0-1.97a7.67 7.67 0 0 0-7.67 7.39l-15.38 413.5c-2 55-17.22 80.17-56 93-21.27 7-78.93 9.39-146.69 9.39-63.55 0-136-2.07-195.66-4.29h-.29a7.682 7.682 0 0 0-7.581 7.54 7.682 7.682 0 0 0 7.301 7.81c59.19 2.2 130.44 4.22 193.7 4.22 70.54 0 131.13-2.51 154-10.09 23.87-7.89 39.92-19.92 50.52-37.86 9.78-16.56 14.86-38.53 16-69.14l15.38-413.53a7.69 7.69 0 0 0-7.39-8z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m425.26 236.4 8.13-11.11 9.14 2.42 9.17.5s-.08 6.72-6.48 6.47-8.65-.5-8.65-.5-1.37 10.65-9.1 12.75",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.12,
    rx: 2.38,
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(9.63 443.174 236.92)",
    width: 14.28,
    x: 436.034,
    y: 234.36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.12,
    rx: 2.43,
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(9.63 443.217 242.852)",
    width: 14.89,
    x: 435.772,
    y: 240.292
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.12,
    rx: 2.43,
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(9.63 442.474 248.972)",
    width: 14.89,
    x: 435.029,
    y: 246.412
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.06,
    rx: 2.4,
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(9.63 440.991 254.31)",
    width: 14.71,
    x: 433.636,
    y: 251.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.94 138.1h45.85v14.53c0 12.664-10.266 22.93-22.93 22.93s-22.93-10.266-22.93-22.93V138.1z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2.19,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.86 129.05c-12.66 0-22.92 4-22.92 9a4.77 4.77 0 0 0 1.64 3.36c3.38 3.33 11.63 5.68 21.28 5.68s17.91-2.35 21.29-5.68a4.81 4.81 0 0 0 1.64-3.36c0-4.95-10.26-9-22.93-9z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2.19,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.87 114.86a4.44 4.44 0 0 0-4.45 4.44v17.92c0 .84 2 1.52 4.45 1.52s4.45-.68 4.45-1.52V119.3a4.45 4.45 0 0 0-4.45-4.44zM454.24 114.86a4.45 4.45 0 0 0-4.45 4.44v17.92c0 .84 2 1.52 4.45 1.52s4.45-.68 4.45-1.52V119.3a4.44 4.44 0 0 0-4.45-4.44z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2.19,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.94 485.69a2.58 2.58 0 0 0-2.68 2.13C227.67 588 224 654 226.29 682.51c.09 1.16.24 2.86.34 4.89h27.81l-13.1-199.26a2.49 2.49 0 0 0-2.4-2.45z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.18 684.6c0 .61-.06 1.21-.09 1.78l-.05 1h.59c-.1-2-.25-3.73-.34-4.89z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.09 686.38c0 .35 0 .69-.05 1zM226.18 684.6l.11-2.09c-.04.73-.07 1.41-.11 2.09zM226 687.4v.78zM226.09 686.38c0-.57.06-1.17.09-1.78zM225.59 696.16s.15-2.9.41-8l-.59 11.45c.1-1.82.18-3.44.18-3.45zM225.41 699.63v.73z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m413.53 233.29 3.74 34-57.9 12.8c-6.32 1.4-12.55 3.17-18.8 4.83-14.79 3.93-35.43-7.18-40.08-21.71-1.07-3.35-2.12-6.7-3.41-10l-32-81.1 34-33.95 41 106.16z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#55f99f",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34 329c-.78-8.41-1-26-2.34-41.45-5.35-61.34-4.18-57.72-5.52-63.67-8.59-38.18-27.07-55.36-17.19-75a31.62 31.62 0 0 1 6-8.26c.22-.22 1.34-1.46 2.84-2.83a105.25 105.25 0 0 1 16.55-11.86c7.77-4.41 17.78-10 29.78-16.5a162.67 162.67 0 0 1 23.34-1.08 166.06 166.06 0 0 1 50.89 9.38 76.25 76.25 0 0 1 17.4 6.25c5.47 2.77 9.65 4.88 13 9.14 1.4 1.8 4.75 6.69 5.18 16.44.62 14-3.58 64.76-11.62 133.1.46 3.89 3.34 31.94-16.46 50.88-16.81 16.07-38.83 14.92-52.37 14.21-29.06-1.53-50.63-11.39-59.48-18.75z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#55f99f",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m276.18 120.68.11.86c-1.48-1.24-3.26-2.54-3.83-2.09-.41.32 0 1.38 0 1.66",
    fill: "#12186d",
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#12186d"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.08 116.47a40.86 40.86 0 0 1-9.83-.13 42.25 42.25 0 0 1-18.51-7.29",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.74 696.75-10.85-500.51s-95.57 8.61-94.83 9.73 8.42 127.56 8.42 127.56L161.34 329l17.86 358.21h46.29l11.79-240.71L257.1 696z",
    fill: "#12186d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.61 220s-22.35-70.65-39.18-95.53l9.54-5.24s42 75.8 44.51 99.23zM278.38 203c-.42 0-5.33-82.77-5.33-82.77l8.84 2.11 7.29 78.55z",
    fill: "#12186d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 314.23s10.58-.86 17.43 1.43 20.29 1.43 22.29 0 2.86-3.43 2.58-4.57 3.71-4 3.14-5.43-1.14-4 .29-5.43-.86-4.58-.86-4.58 3.14-4.28-.86-7.14c-2.86-1.43-13.43-1.43-13.43-1.43s-.86 0-.57-1.43 3.14-6 3.14-8.57.29-9.72-5.43-9.14c0 0-.86 9.14-4 10.57s-6.57 12-8 13.14-4.57 4.29-15.43 2.86",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.71 708.24.69 9 18.17.5 5.19-4.91 5.82 5.47s48.71 8.7 53.42-10.88c-3.65 1.7-8.55 2.85-15.12 3.08-27.19.94-58.51-1.44-68.17-2.26z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.3 676.55-.93-72.55-54.62 1.5 8 102.76c9.66.82 41 3.2 68.12 2.26 6.57-.23 11.47-1.38 15.12-3.08 0-.09.05-.19.08-.29 1.54-7.5-35.77-30.6-35.77-30.6z",
    fill: "#55f99f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.39 709.88.7 9 18.17.49 5.19-4.9 5.82 5.47s48.71 8.73 53.37-10.87c-3.65 1.7-8.55 2.85-15.12 3.08-27.14.93-58.46-1.45-68.13-2.27z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227 678.19 5.52-71.73-61.07.66 7.95 102.76c9.67.82 41 3.2 68.13 2.26 6.57-.23 11.47-1.38 15.12-3.08 0-.09.05-.19.07-.29 1.58-7.48-35.72-30.58-35.72-30.58zM145.16 137.78a44.65 44.65 0 0 0-8.87 11.09 48.6 48.6 0 0 0-5.76 18 54.6 54.6 0 0 0 1.3 21.34c.75 2.77 3.35 8.18 8.52 18.89 1.62 3.34 1.78 3.65 7 14.25l9.72 19.86c3.81 7.77 5.52 11.26 5.52 11.27 2.05 4.2 4.12 8.4 6.17 12.61 5.71 11.71 6.21 12.9 8.11 15.28a39 39 0 0 0 9.53 8.56c5.4 3.4 10 4.33 15 5.53 8 1.92 15.63 4.94 23.56 7 9.33 2.42 49.86 11.37 70.94 18.22.88-10.39 5.46-19.92 6.34-30.3-5.55-2.08-41-10-46.59-12l-40.75-15.23L201.38 230c-3.047-7.267-6.1-14.543-9.16-21.83l-5.16-11.61",
    fill: "#55f99f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.87 84.72c0 2.92-.77 13.62-2.9 17.6a22.49 22.49 0 0 1-5.05 6.35c-1.24.85-2.34 1.67-3.28 2.41a136.19 136.19 0 0 0 11.27 13 132.85 132.85 0 0 0 18.2 15.53 180.19 180.19 0 0 0 23.55 13.56c.89-6.28 2-14.79 3.21-24.91.55-4.79.93-8.37 1.16-11.13-23.45 2.6-39.91-23.83-46.16-32.41z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.25 111.81a34 34 0 0 0 4.46 7.53c2.18 2.77 4.77 6.06 9.36 7.85a18.21 18.21 0 0 0 8.8 1.06l1.21-11.78a40.37 40.37 0 0 1-9.83-.13 41.26 41.26 0 0 1-14-4.53",
    fill: "#12186d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.68 36.81c-2.91-6.75-6.77-15.71-16.19-20.73-15.72-8.36-33.66 1.34-37.45 3.38-4.18 2.26-17.44 9.43-20.78 22.95-.56 2.29-1.08 5.73 2.37 24 1.86 9.85 3.74 18 5.17 23.8a24.06 24.06 0 0 1 .73 4.34c23.28 28.4 43.44 22.19 48.19 21.37a26.57 26.57 0 0 0 13.79-7.35c2.58-2.66 5.45-7 6.89-28.09 1.47-21.4 2.25-32.12-2.72-43.67z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "m267.22 62.17 6.29 22.86-10.35.78",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.86,
    cy: 65.77,
    fill: "#12186d",
    fillRule: "nonzero",
    r: 2.74
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.52,
    cy: 65.77,
    fill: "#12186d",
    fillRule: "nonzero",
    r: 2.74
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.32 60.82c2.14-3.62 6.77-4.91 10.7-4.75 1.61.06 1.61-2.44 0-2.5-4.82-.2-10.27 1.62-12.86 6a1.25 1.25 0 1 0 2.16 1.26z",
    fill: "#12186d",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.08 73.78a44.11 44.11 0 0 0 12.19-5.35c6.8-4.33 8.8-8.31 16.2-14a68.42 68.42 0 0 1 11.84-7.27c-9-.53-18.69-.73-28.92-.45-5.55.15-10.91.44-16.07.83.54 4.57 1.26 9.41 2.21 14.47.78 4.11 1.64 8 2.55 11.74",
    fill: "#12186d",
    fillRule: "nonzero",
    opacity: 0.51,
    stroke: "#12186d",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.74 64.46c-6.17-.56-10.9 3.87-11 8-.14 4.35 4.89 9.37 11.52 8.51",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.26 111.35a17.66 17.66 0 0 1-4.58-3.43 20.86 20.86 0 0 1-4-5.9c-.63-1.38-1.51-3.77-2.13-13.34-.28-4.23-.36-7.72-.39-10.1a54.3 54.3 0 0 0 5.53 3.71c15.51 9 31.49 7.83 36.57 7.38a67.68 67.68 0 0 0 15.84-3.39 49.06 49.06 0 0 1-1.65 11.31c-1.14 4.23-2 7.42-4.72 10.47a19.79 19.79 0 0 1-6.61 4.65 35.3 35.3 0 0 1-14.75 3.36 39.88 39.88 0 0 1-19.11-4.72z",
    fill: "#12186d",
    fillRule: "nonzero",
    opacity: 0.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.51 98.76c0 .23-.07.47-.12.7-1.176 5.492-6.583 8.991-12.075 7.815s-8.991-6.583-7.815-12.075c0-.16.08-.3.12-.45z",
    style: {
      stroke: "#12186d",
      strokeWidth: 2,
      fill: "#fff",
      fillRule: "nonzero",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.66 54.79c14.84-.7 27.42-2 37.11-3.21 0 0 11.89-1.5 49-14.35 2.06-.72 6.63-2.38 8.45-6.79 1.16-2.81 1.27-6.92-.71-9.39-1.55-1.93-3.85-2.21-5.78-2.44 0 0-2.89-.34-20.37-2.57-6-.76-5.42-1.64-12.93-3.13a93.15 93.15 0 0 0-28.84-1.11c-11 1.32-16.52 2-20.5 5.64-11.35 10.41-6.09 34.32-5.43 37.35z",
    fill: "#12186d",
    fillRule: "nonzero",
    stroke: "#12186d",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.47 86.13s1 9.15-2.53 17.35l23.91 10.7L214 91.6l-8.29-5.6",
    fill: "#fff",
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M266.32 53.07c-1.5.56-.85 3 .66 2.42a10.67 10.67 0 0 1 9.02 1.28V54a12.4 12.4 0 0 0-9.68-.93zM276 54v2.81c.17.1.34.2.5.31v-2.9z",
    fill: "#12186d",
    fillRule: "nonzero"
  }))));
};

export default SvgPlug;